var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
var BIOMETRIC_REPLICA_FAILED_MESSAGE = "Compareça ao Detran mais próximo com um documento oficial com foto e o número do RENACH para refazer a captura da biometria referente ao processo de renovação iniciado via GovPi Cidadão.";
export function TimelineDescriptionDotDataCaptureError() {
    return _jsx("span", __assign({ className: "text-xs" }, { children: BIOMETRIC_REPLICA_FAILED_MESSAGE }));
}
